import * as DashboardApi from "../../../../apiCall/dashboard/index.js";
import * as constants from "../../widgetConstants.js";
import {getNoData} from "../../items/index.js";
import {widgetBoard} from "../../index.js";
import {BridgeSend, isMobile, updateEndFilter} from "../../event.js";
import Widget from "../widget.js";
import {subscribeWidget} from "../../../main-socket/index.js";
import {WIDGET} from "../../widgetConstants.js";

export class WorkWidget extends Widget {

    async setup(props) {
        return super.setup(props);
    }

    setTitle(){
        return true;
    }

    async getData(v) {
        /*내 업무(1), 요청한 업무(2) api 호출부*/
        const fil_end_dt_gubun = $(this.$target).find('.widget-filter-mini-pop input:checked').attr('data-fil-type')
        const taskData = await DashboardApi.getApi('getTaskList', ({
            ...constants.taskData(),
            // FIL_END_DT_GUBUN: fil_end_dt_gubun,
            FILTER_GB: this.$props.FILTER_GB,
            EndEndDt: Time.format(getLastDate(fil_end_dt_gubun), 'type12'),
            EndStartDt: Time.format(getStartDate(fil_end_dt_gubun), 'type12'),
        }))

        /* 가져온 값을 임박/지연 탭으로 나누기위해 리스트 생성 */
        this.$props.deadlineArr = []
        this.$props.delayArr = []
        this.$props = {...this.$props, ...taskData}
        this.$props["TASK_REC"].forEach(task => {
            if (Often.null2Void(task.END_DT, '') === '') return;

            if (fil_end_dt_gubun === '1' && Time.format(task.END_DT, 'type12') > Time.currentTime('type12')) {
                // 필터가 오늘인 경우에는 내일 날짜까지 조회되므로 포함안함.
            } else if (task.END_DT.length === 8 &&
                Time.format(task.END_DT, 'type12') === Time.currentTime('type12'))
            {
                // 값이 시간이 없이 '오늘'인 경우에는 시간변환시 00시 기준으로 계산되므로 현재보다 늦다.
                this.$props.deadlineArr.push(task)
            } else if (Time.format(task.END_DT, 'type19') > Time.currentTime('type19')) {
                this.$props.deadlineArr.push(task)
            } else if (Time.format(task.END_DT, 'type19') <= Time.currentTime('type19')) {
                this.$props.delayArr.push(task)
            }
        })

        return {recordData: this.$props.deadlineArr};
    }

    render() {
        this.$props.isDeadline = $(this.$target).find('.widget-tab-title .tab_1.active').length > 0;
        const data = this.$props.isDeadline ? this.$props.deadlineArr : this.$props.delayArr;
        const $taskList = $(this.$target).find('.js-widget-article-list');
        if (!data || data.length === 0) {
            $taskList.html(this.$props.isDeadline ? getNoData('deadline') : getNoData('delay'));
            this.mounted.bind(this)();
            return;
        }
        $taskList.empty();
        $taskList.drawListHelper({
            records: data,
            callback: {
                item: getInnerTaskLiHtml,
            }
        })
    }

    mounted() {
        super.mounted();

        $(this.$target).find('.tab_1 > span').text(this.$props.deadlineArr.length);
        $(this.$target).find('.tab_2 > span').text(this.$props.delayArr.length);
        $(this.$target).find('.widget-article-list').removeClass('dash-pending')
        $(this.$target).find('.dash-num-pending').remove()

        subscribeWidget({
            USER_ID: _USER_ID,
            COLABO_SRNO: this.$props.COLABO_SRNO,
            TYPE: this.$props.FILTER_GB === '1'? WIDGET.MY_TASK.SRNO : WIDGET.REQUEST_TASK.SRNO
        })
    }

    setEvent() {
        $(this.$target).off('click').on('click', (e) => {
            const $eTarget = $(e.target);

            /*필터버튼*/
            if ($eTarget.closest('.button-filter').length > 0) {
                const $pop = $(this.$target).find('.widget-filter-mini-pop');
                $pop.toggleClass('d-none');
            }

            /*필터팝업*/
            if ($eTarget.closest('.js-filter-input').length > 0) {
                if (!$eTarget.closest('.js-filter-input').length) return;
                const id = $eTarget.closest('.js-filter-input').attr('id')
                const WIDGET_USER_SRNO = id.split('_')[0];
                const filter = id.split('_')[2];
                $(`#${WIDGET_USER_SRNO} > ul > li`).attr('fil_end_dt_gubun', filter);
                const fil_end_dt_gubun = $(`#${WIDGET_USER_SRNO}`).find('.active').attr('fil_end_dt_gubun');

                if ($eTarget.closest('.widget-my-work').length) {
                    updateEndFilter(e, fil_end_dt_gubun).then(r => {
                        widgetBoard.$state.myWork.setup({isDataDrivenRendering: true})
                    });
                    $eTarget.closest('.widget-my-work').find('.button-filter > span').text(i18next.t(constants.end_dt_filter[filter - 1]));
                } else if ($eTarget.closest('.widget-request-work').length) {
                    updateEndFilter(e, fil_end_dt_gubun).then(r => {
                        widgetBoard.$state.requestWork.setup({isDataDrivenRendering: true})
                    });
                    $eTarget.closest('.widget-request-work').find('.button-filter > span').text(i18next.t(constants.end_dt_filter[filter - 1]));
                }

                const $pop = $eTarget.closest('.widget-filter-mini-pop');
                $pop.toggleClass('d-none');
            }

            /*탭*/
            if ($eTarget.closest('.widget-tab-title li').length > 0) {
                if ($eTarget.closest('.active').length > 0) return; //같은 탭 클릭 시 return

                //다른 탭 클릭 시 active 클래스 부여
                $eTarget.closest('.widget-tab-title').find('.active').removeClass('active');
                $eTarget.closest('.widget-tab-title > li').addClass('active');
                // workList({WIDGET_USER_SRNO : $eTarget.closest('li[id]').attr('id')});
            }

            /*요청한업무*/
            if (($eTarget.closest('.widget-request-work .widget-tab-title li').length > 0)) {
                widgetBoard.$state.requestWork.render()
            }

            /*내업무*/
            if (($eTarget.closest('.widget-my-work .widget-tab-title li').length > 0)) {
                widgetBoard.$state.myWork.render()
            }

            /*업무조회*/
            if ($eTarget.closest(".task-item").length > 0) {
                const $taskItem = $eTarget.closest(".task-item");
                const COLABO_SRNO = $taskItem.attr("data-project-srno");
                const COLABO_COMMT_SRNO = $taskItem.attr("data-post-srno");
                if (isMobile) {
                    const jsonData = {
                        CODE: "PROJECT_DETAIL",
                        COLABO_SRNO,
                        COLABO_COMMT_SRNO,
                        COLABO_REMARK_SRNO: "-1" // "" or -1
                    };
                    BridgeSend(jsonData);
                } else {
                    PostPopup.togglePostView(COLABO_SRNO, COLABO_COMMT_SRNO, "");
                }
            }
        });
    }
}


/*내 업무, 요청한 업무 아이템 리스트 dom으로 변환하여 반환하는 함수*/
const getInnerTaskLiHtml = (taskSectionDataList) => {
    return taskSectionDataList.map((taskData) => {
        return getTaskItem(taskData)
    }).join('');
}

const getTaskItem = (data) => {
    const {
        COLABO_COMMT_SRNO,
        COLABO_SRNO,
        TASK_NM,
        STTS,
        END_DT,
        PRIORITY
    } = data;

    const PRIORITY_ICON = PRIORITY ? "icons-" + DetailCode.PRIORITY._GB[PRIORITY] : "";
    return `<li id="allTask-${COLABO_COMMT_SRNO}" class="task-item" data-project-srno="${COLABO_SRNO}" data-post-srno="${COLABO_COMMT_SRNO}">
                <span class="status ${TaskCode.OPTION._GB[Number(STTS)]}">
                    ${i18next.t(TaskCode.OPTION._GB_NM[Number(STTS)])}
                </span>
                <p>${Mutil.tag2html(TASK_NM)}</p>
                <span class="priority"><i class="${PRIORITY_ICON}"></i></span>
                <span class="due-date">${isAllDay(END_DT)}</span>
            </li>
            `

}

const isAllDay = (END_DT) => {
    return END_DT.length === 8 ? Time.format(END_DT, i18next.t(date.format.type29)) : Time.format(END_DT, i18next.t(date.format.type28));
}

/*1:오늘까지, 2: 이번주까지, 3: 이번달까지의 마감일 검색 종료 날짜를 반환하는 함수*/
const getLastDate = (fil_end_dt_gubun) => {
    let day = dayjs().toDate();
    if (fil_end_dt_gubun === '1') {
        day = new Date(day.getFullYear(), day.getMonth(), day.getDate() + 1)
        return day;
    }
    if (fil_end_dt_gubun === '3') {
        day = new Date(day.getFullYear(), day.getMonth() + 1, 0);
        return day
    }

    const weekDay = day.getDay();
    day.setDate(day.getDate() + 7 - weekDay);
    return day;
}

/*1:오늘까지, 2: 이번주까지, 3: 이번달까지의 마감일 검색 시작 날짜를 반환하는 함수*/
const getStartDate = (fil_end_dt_gubun) => {
    let day = dayjs().toDate();
    if (fil_end_dt_gubun === '1') {
        day = new Date(day.getFullYear(), day.getMonth(), day.getDate())
        return day;
    }
    if (fil_end_dt_gubun === '3') {
        day = new Date(day.getFullYear(), day.getMonth(), 1);
        return day
    }

    const weekDay = day.getDay();
    day.setDate(day.getDate() - weekDay + 1);
    return day;
}

